"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _uiKit = require("@devsta/ui-kit");

var _searchableResourceTypes = _interopRequireDefault(require("../../constants/searchableResourceTypes"));

require("./_source-tags.scss");

var _TYPE_ICON_MAP;

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var TYPE_ICON_MAP = (_TYPE_ICON_MAP = {}, _defineProperty(_TYPE_ICON_MAP, _searchableResourceTypes.default.PROJECT, 'folder'), _defineProperty(_TYPE_ICON_MAP, _searchableResourceTypes.default.VIDEO, 'video'), _TYPE_ICON_MAP);

function deleteTagAtIndex(index, onDelete) {
  return function () {
    return onDelete(index);
  };
}

function SourceTags(_ref) {
  var tags = _ref.tags,
      onDeleteTag = _ref.onDeleteTag;
  return (/*#__PURE__*/_react.default.createElement("div", {
      className: "source-tags"
    }, tags.map(function (tag, index) {
      return (/*#__PURE__*/_react.default.createElement("div", {
          className: "source-tags__tag",
          key: tag.id
        }, /*#__PURE__*/_react.default.createElement("div", {
          className: "source-tags__tag__left-content"
        }, /*#__PURE__*/_react.default.createElement(_uiKit.Icon, {
          color: "white",
          name: TYPE_ICON_MAP[tag.type],
          size: 15
        }), /*#__PURE__*/_react.default.createElement("span", {
          className: "source-tags__tag__left-content__text"
        }, tag.displayName)), /*#__PURE__*/_react.default.createElement(_uiKit.Icon, {
          color: "white",
          size: 10,
          onClick: deleteTagAtIndex(index, onDeleteTag),
          name: "close"
        }))
      );
    }))
  );
}

var _default = (0, _react.memo)(SourceTags);

exports.default = _default;